<template>
  <div class="otp">
    <h3>تایید {{ $athenType[$route.params.authType] }}</h3>
    <form @submit.prevent="handleSubmit(code)" class="ci-container">
      <div class="title">
        <span>
          کد ارسال شده به
          {{ $athenType[$route.params.authType] }}
          <span style="direction: ltr" dir="ltr">{{ username }}</span>
          را وارد کنید
        </span>
        <!-- <a
          @click.prevent="
            $router.push(
              $route.query.forgetPasword
                ? `/forgetpass?type=${$route.params.authType}`
                : '/login'
            )
          "
          :href="`/forgetpass?type=${$route.params.authType}`"
          class="back"
        >
          استفاده از {{ $athenType[$route.params.authType] }} دیگر
        </a> -->
      </div>
      <div class="" @paste="paste">
        <CodeInput
          :loading="false"
          class="verif-code"
          :fieldWidth="$detectDevice() === 'MOBILE' ? 40 : 48"
          :fieldHeight="$detectDevice() === 'MOBILE' ? 40 : 48"
          @change="code = $event"
          @complete="handleSubmit"
          ref="code-input"
        />
      </div>
      <span
        @click="counter ? null : resendBtn()"
        class="counter"
        v-if="$route.params.authType !== 'GOOGLE_AUTHENTICATOR'"
      >
        {{ counter ? counter : "ارسال مجدد کد" }}
      </span>
      <button :disabled="code.length != 6" class="submit">تایید</button>
    </form>
  </div>
</template>

<script>
import CodeInput from "vue-verification-code-input";
import { reset, paste } from "@/library/reuseableFunction";
export default {
  name: "Otp",
  components: {
    CodeInput,
  },
  data() {
    return {
      counter: 120,
      timeOut: null,
      username: this.$cookies.get("username"),
      code: "",
    };
  },
  computed: {},
  methods: {
    async resendBtn() {
      this.state.loading = true;

      await this.reset();
      await this.$axios.post("/users/resend-otp-code", {
        username: this.username,
      });
      this.$error(
        "کد جدید به " +
          this.$athenType[this.$route.params.authType] +
          " شما ارسال شد.",
        "",
        "success"
      );
      if (this.counter === 0) {
        this.counter = 120;
        this.countDownTimer();
      }
    },
    countDownTimer() {
      if (this.counter > 0) {
        this.timeOut = setTimeout(() => {
          this.counter--;
          this.countDownTimer();
        }, 1000);
      } else {
        this.$error("زمان شما به اتمام رسید", "");
      }
    },
    handleSubmit(e) {
      if (this.$route.name == "OtpForm") {
        console.log(this.$route.name);
        this.submitAuth();
      } else if (this.$route.name == "OtpForgetPass") {
        console.log(this.$route.name);
        this.submitForget(e);
      }
    },
    async submitAuth() {
      if (!this.disabled) {
        this.state.loading = true;
        let body = {
          code: this.code,
        };
        if (this.$validEmail(this.username)) {
          body.email = this.username;
        } else {
          body.mobileNumber = this.username;
        }
        const res = await this.$axios.post("/users/check-otp-code", body);

        if (res.token) {
          await this.$setToken(res.token);
          await this.$getuserInfo();

          !this.state.userInfo.authorized
            ? await this.$router.push({ name: "Account" })
            : await this.$router.push("/dashboard");
        }
      }
    },
    async submitForget(e) {
      if (!this.disabled) {
        this.otp.code = e;
        this.state.loading = true;
        const res = await this.$axios.post(
          "/users/v2/check-otp-password",
          this.otp
        );
        this.state.otp = this.otp.code;
        if (res.token) {
          this.state.otptoken = res.token;
          await this.$router.push({ name: "NewPass" });
        }
      }
    },
    paste,
    reset,
  },
  beforeDestroy() {
    clearTimeout(this.timeOut);
  },
  mounted() {
    if (this.$route.params.authType !== "GOOGLE_AUTHENTICATOR") {
      this.countDownTimer();
    }
  },
};
</script>

<style lang="scss" scoped>
.otp {
  z-index: 5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media (max-width: 600px) {
    margin-top: -40px;
  }
  h3 {
    font-family: "sepahbod";
    font-size: clamp(20px, 3vw, 24px);
  }
  .ci-container {
    display: flex;
    flex-direction: column;
    row-gap: 32px;
    padding: 32px 24px;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    background: var(--box);
    @media (max-width: 600px) {
      padding: 16px 12px;
    }
    .title {
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      a {
        text-align: end;
        color: var(--primary-color);
        font-size: clamp(12px, 1vw, 14px);
      }
    }
  }
  .counter {
    cursor: pointer;
    align-self: start;
  }
}

::v-deep .react-code-input-container .react-code-input {
  @media (max-width: 600px) {
    column-gap: 8px;
  }
}
</style>
